const ScheduleStatus = {
  noStatus: 0,
  confirmed: 1,
  accomplished: 2,
  canceled: 3,
  absent: 4,
};

export default ScheduleStatus;